import type { ApiSourceLabelPair } from '@highimpact-frontend/api-types';

import { getSourceLabelPairsKey } from './sourceLabelQueryUtils';

/** Stable TanStack Query keys for dashboard library server state. */
export const dashboardQueryKeys = {
  all: ['dashboard'] as const,

  campaigns: (siteId: number | null | undefined) =>
    [...dashboardQueryKeys.all, 'campaigns', siteId ?? 'none'] as const,

  resources: (resourceIds: readonly number[]) =>
    [
      ...dashboardQueryKeys.all,
      'resources',
      [...resourceIds].sort((left, right) => left - right).join(','),
    ] as const,

  sourceLabels: (
    projectId: number | null | undefined,
    siteId: number | null | undefined,
    pairs: readonly ApiSourceLabelPair[]
  ) =>
    [
      ...dashboardQueryKeys.all,
      'sourceLabels',
      projectId ?? 'none',
      siteId ?? 'none',
      getSourceLabelPairsKey(pairs),
    ] as const,

  measureTypes: () =>
    [...dashboardQueryKeys.all, 'measureTypes'] as const,

  measure: (signature: string) =>
    [...dashboardQueryKeys.all, 'measure', signature] as const,
};
